import { OrganizationalUnitResourceType } from "@shuttlerock/api-types/federated";

export enum AccountType {
  License = "LICENSE",
  LicensePlus = "LICENSE_PLUS",
  Subscription = "SUBSCRIPTION",
  Unrestricted = "UNRESTRICTED",
}

export type ClientAccount = {
  resourceKey?: string;
  key: string;
  organizationalUnitKey?: string;
  name: string;
  type: OrganizationalUnitResourceType;
  accountType: AccountType;
};

export type DefaultClientAccount = ClientAccount & {
  isPlatformAiEnabled: boolean;
};

export type ClientBrand = {
  resourceKey?: string;
  key: string;
  organizationalUnitKey?: string;
  name: string;
  type: OrganizationalUnitResourceType;
};

export type ClientAccountContext = {
  /** The users default account, undefined if they have access to more than one account */
  defaultAccount?: DefaultClientAccount;
  /** The users default brand, undefined if they have access to more than one brand */
  defaultBrand?: ClientBrand;
  /** Whether the user has access to more than one ClientAccount */
  isMultiAccountUser: boolean;
  /** Whether the user has access to more than one ClientBrand */
  isMultiBrandUser: boolean;
};
